import { CmsImage } from '@domgen/dgx-fe-cms';

export interface CmsHighlightedPartners {
  highlightedPartnersTitle?: string;
  highlightedPartners: CmsImage[];
}
